import { FormHelperText, Radio, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  StyledTableCell,
  TableRowHead,
  useStyles
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

export default function VisaIssuanceSection({ formik, colSpan = 3, hideOverseas = false, hideThailandExpiryDate = false, disabled = false, }) {
  const classes = useStyles();
  const masterData = useSelector(selectMasterData);

  const visaTypeConfig = get(masterData, "visaTypeConfig", []);
  const countryConfig = get(masterData, "countryEmbassy", []);
  const theImmigrationBureauConfig = get(
    masterData,
    "theImmigrationBureauConfig",
    []
  );
  const canEdit = useSelector(canEditForm);
  return (
    <TableBody style={{ width: "100%" }}>
      <TableRowHead>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography variant="h6" className={classes.title}>
                Visa Issuance
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRowHead>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <InputLabel>
            Please select the place to collect the LTR Visa stamp. For dependants, the visa issuance place must be the same place as the main LTR applicant.
          </InputLabel>
          {hideOverseas !== true && <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Radio
                      disabled={disabled || !canEdit}
                      name="visaissuance.overseas"
                      value={formik.values.visaissuance.overseas}
                      checked={Boolean(formik.values.visaissuance.overseas)}
                      onClick={() => {
                        formik.setFieldValue(
                          "visaissuance.overseas",
                          true,
                          false
                        );
                        formik.setFieldValue(
                          "visaissuance.thailand",
                          false,
                          false
                        );
                        formik.setFieldValue(
                          "visaissuance.theImmigrationBureauID",
                          null,
                          false
                        );

                        formik.setFieldError(
                          "visaissuance.theImmigrationBureauID",
                          ""
                        );
                        formik.setFieldError("visaissuance.countryId", "");
                        formik.setFieldError("visaissuance.cityId", "");

                        formik.setFieldValue("visaissuance.visaTypeId", null);
                        formik.setFieldValue("visaissuance.visaExp", null);
                        formik.setFieldError("visaissuance.visaTypeId", "");
                        formik.setFieldError("visaissuance.visaExp", "");
                      }}
                    />
                  }
                  label="Overseas; Thai Embassy or Consulate in"
                />

                <div className={classes.flexRow}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    error={isError("visaissuance.countryId", formik)}
                    disabled={
                      formik.values.visaissuance.overseas ? false : true
                    }
                  >
                    <InputLabel>Country</InputLabel>
                    <Select
                      disabled={disabled || !canEdit}
                      label="Country"
                      name="visaissuance.countryId"
                      value={formik.values.visaissuance.countryId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {countryConfig.map((country) => (
                        <MenuItem
                          value={country.countryId}
                          key={country.countryId}
                        >
                          {country.countryName}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      error={isError("visaissuance.countryId", formik)}
                    >
                      {getErrorMessage("visaissuance.countryId", formik)}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    error={isError("visaissuance.cityId", formik)}
                    disabled={
                      formik.values.visaissuance.overseas ? false : true
                    }
                  >
                    <InputLabel>City</InputLabel>
                    <Select
                      disabled={disabled || !canEdit}
                      label="City"
                      name="visaissuance.cityId"
                      value={formik.values.visaissuance.cityId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {get(
                        countryConfig.filter(
                          (country) =>
                            country.countryId ===
                            formik.values.visaissuance.countryId
                        ),
                        "0.cityConfig",
                        []
                      ).map((country) => (
                        <MenuItem value={country.cityID} key={country.cityID}>
                          {country.cityName}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      error={isError("visaissuance.cityId", formik)}
                    >
                      {getErrorMessage("visaissuance.cityId", formik)}
                    </FormHelperText>
                  </FormControl>
                </div>
              </FormGroup>
            </div>
          </div>}

          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Radio
                      disabled={disabled || !canEdit}
                      name="visaissuance.thailand"
                      value={formik.values.visaissuance.thailand}
                      checked={Boolean(formik.values.visaissuance.thailand)}
                      onClick={() => {
                        formik.setFieldValue(
                          "visaissuance.thailand",
                          true,
                          false
                        );
                        formik.setFieldValue(
                          "visaissuance.overseas",
                          false,
                          false
                        );
                        formik.setFieldValue(
                          "visaissuance.countryId",
                          null,
                          false
                        );
                        formik.setFieldValue(
                          "visaissuance.cityId",
                          null,
                          false
                        );

                        formik.setFieldError(
                          "visaissuance.theImmigrationBureauID",
                          ""
                        );
                        formik.setFieldError("visaissuance.countryId", "");
                        formik.setFieldError("visaissuance.cityId", "");
                      }}
                    />
                  }
                  label="Thailand"
                />
                <div className={classes.flexRow} style={{ flex: 1 }}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{ width: "100%" }}
                    error={isError(
                      "visaissuance.theImmigrationBureauID",
                      formik
                    )}
                    disabled={
                      formik.values.visaissuance.thailand ? false : true
                    }
                  >
                    <InputLabel>The Immigration Bureau</InputLabel>
                    <Select
                      disabled={disabled || !canEdit}
                      label="The Immigration Bureau"
                      name="visaissuance.theImmigrationBureauID"
                      id="visaissuance.theImmigrationBureauID"
                      key={formik.values.visaissuance.thailand}
                      value={formik.values.visaissuance.theImmigrationBureauID}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {theImmigrationBureauConfig.map(
                        (theImmigrationBureau) => (
                          <MenuItem
                            value={theImmigrationBureau.theImmigrationBureauID}
                            key={theImmigrationBureau.theImmigrationBureauID}
                          >
                            {theImmigrationBureau.theImmigrationBureauName}
                          </MenuItem>
                        )
                      )}
                    </Select>
                    <FormHelperText
                      error={isError(
                        "visaissuance.theImmigrationBureauID",
                        formik
                      )}
                    >
                      {getErrorMessage(
                        "visaissuance.theImmigrationBureauID",
                        formik
                      )}
                    </FormHelperText>
                  </FormControl>
                </div>
              </FormGroup>
            </div>
          </div>

          {formik.values.visaissuance.thailand && !hideThailandExpiryDate && (
            <>
              <br />
              <InputLabel>
                If you are currently on Thai visa, please specify the type of
                visa and its expiry date.
              </InputLabel>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <FormGroup row>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ marginTop: 22, width: 200 }}
                    >
                      <InputLabel>Selected type of visa</InputLabel>
                      <Select
                        disabled={disabled || !canEdit}
                        label="Selected type of visa"
                        name="visaissuance.visaTypeId"
                        value={formik.values.visaissuance.visaTypeId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {visaTypeConfig.map((visaType) => (
                          <MenuItem
                            key={visaType.visatypeId}
                            value={visaType.visatypeId}
                          >
                            {visaType.visaTypeName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <DatePicker
                      disabled={disabled || !canEdit}
                      className={classes.formControl}
                      style={{ marginTop: 21 }}
                      inputVariant="outlined"
                      disableFuture={false}
                      disablePast
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Expiry date"
                      views={["year", "month", "date"]}
                      value={formik.values.visaissuance.visaExp || null}
                      onChange={(date) => {
                        formik.setFieldValue(
                          `visaissuance.visaExp`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(`visaissuance.visaExp`, formik)}
                      helperText={getErrorMessage(
                        `visaissuance.visaExp`,
                        formik
                      )}
                    />
                  </FormGroup>
                </div>
              </div>
            </>
          )}
        </StyledTableCell>
      </TableRow>

      <div />
    </TableBody>
  );
}
